import { customAxios, IDUSUARIO, GENERIC_URL, ENTREGAS_URL } from '../constants';
import { FETCH_FILIALES, FETCH_FILIALES_X_ZONAS, FETCH_FILIALES_X_ZONAS_X_AREAS } from './types';
import { evalAction, serverError } from '../utils/actionError';

export function fetchFiliales() {
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  const request = customAxios.post(`${GENERIC_URL}/filial/accesoUsuarioListar`, [], config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: FETCH_FILIALES,
    payload: request,
  };
}

export function fetchFilialesPorZonas(zonas) {
  const config = {
    params: {
      codZona: `[${zonas}]`,
      indInactivo: 'N',
    },
  };

  const request = customAxios.get(`${GENERIC_URL}/zona/filiales`, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: FETCH_FILIALES_X_ZONAS,
    payload: request,
  };
}

export function fetchFilialesPorZonasPorArea(zonas, areas) {
  const config = {
    params: {
      codAreaVta: areas.length < 1 ? '' : `[${areas}]`,
      codZona: zonas.length < 1 ? '' : `[${zonas}]`,
    },
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  const request = customAxios.get(`${ENTREGAS_URL}/entrega-vehiculo-maestro/filiales/area/zona`, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: FETCH_FILIALES_X_ZONAS_X_AREAS,
    payload: request,
  };
}



// WEBPACK FOOTER //
// ./src/actions/Filiales.js